import type { SectionType } from './types'

export const SECTION_ID: Record<string, SectionType> = {
  SALE_INFO: 'saleInfo',
  ASSESSMENT: 'assessment',
  DOCUMENTS: 'documents',
  SHIPPING: 'shipping',
}
